import styled from 'styled-components';
import { BaSeTheme } from '@base/react';

export const PaddingContainer = styled.div`
  @media screen and (max-width: ${BaSeTheme.breakpoints.tablet.maxWidth}px) {
    padding: 0 8px;
  }
`;

export const JumbotronProdutos = styled(PaddingContainer)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
`;

export const SearchContainer = styled(JumbotronProdutos)`
  align-items: flex-end;
`;

export const InputWrapper = styled.div`
  max-width: ${BaSeTheme.breakpoints.tablet.maxWidth}px;
`;

export const DataTableWrapper = styled.div`
  padding: ${({ isDesktop }) => (isDesktop ? '24px 0 32px' : '0 0 32px')};

  .BaSe--data-pagination {
    display: ${({ noItems }) => (noItems ? 'grid' : 'flex')};
    height: auto;
  }

  margin-bottom: 100px;
  .BaSe--data-filter-area {
    border-bottom: 1px solid ${BaSeTheme.colors.institucionais.cinzaSebrae90};
    border-top: none;
  }

  .BaSe--data-body-list {
    padding: ${({ isDesktop }) => (isDesktop ? ' 24px' : ' 24px 0')};
  }

  .BaSe--data-filter-area > div {
    padding: ${({ isDesktop }) => (isDesktop ? ' 0 24px 10px' : ' 16px 0')};
  }

  .BaSe--data-table-column-filter {
    will-change: inherit;
  }

  .BaSe--data-filter-area > div {
    gap: 0;
    div {
      will-change: inherit;
    }
  }

  .BaSe--data-header {
    padding: 24px 24px 0;
  }
`;

export const ActionItemWrapper = styled.div`
  .BaSe--action-item-open {
    width: 290px;
  }
`;

export const NotFoundServiceContent = styled.div`
  display: grid;
  place-items: center;
  margin: 30px 0;
`;

export const WrapperActions = styled.div`
  display: flex;
  gap: 10px;
`;

export const ClientWrapper = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
  margin-top: ${(props) => (props.isStatus ? '2px' : '5px')};
  word-break: break-word;
`;

export const CustomFilterContent = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: end;

  @media (max-width: 769px) {
    display: grid;
    justify-content: start;
    margin: 0 2px;
    gap: 0;
  }
`;

export const ButtonSelectOption = styled.div`
  margin-top: 10px;
  place-items: center;
  display: grid;
`;

export const WrapperCheckbox = styled.div`
  margin: 16px 0;

  @media (max-width: 404px) {
    flex: ${({ index }) => (index === 0 ? 0.6 : 1)};
  }
`;

export const ContentCertificadoPDF = styled.div`
  display: grid;
  gap: 24px;
`;

export const WrapperIframe = styled.div`
  position: relative;
  width: 100%;
  border: none;
  padding-top: 0;
  height: 73vh;

  @media (max-width: 575px) {
    height: 30vh;
  }

  @media (min-width: 576px) {
    height: 53vh;
  }

  @media (min-width: 768px) {
    height: 67vh;
  }

  @media (min-width: 992px) {
    height: 80vh;
  }
`;

export const Iframe = styled.iframe`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: none;
  margin: 0;
  padding: 0;
  display: block;
`;

export const WrapperButtons = styled.div`
  position: relative;
  top: 6px;
  margin: 16px;
  width: 100%;
  display: flex;
  gap: 24px;
`;

export const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 2px 10px;
  border-radius: 999px;
  background-color: ${({ ativo }) =>
    ativo
      ? BaSeTheme.colors.feedbackInterface.sucesso75
      : BaSeTheme.colors.feedbackInterface.erro75};
`;
